module.exports = __webpack_public_path__ + "media/site_templates/www.cheapgardenservices.com.au/images/our_services_2-938cb139e6cb3a79d4357bc79408490e.jpg";